// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Classes */\n.side-menu-footer {\n    position: absolute;\n    bottom: -1px;\n    width: 100%;\n    border-top: 1px solid #dfe2e6;\n}", ""]);
// Exports
module.exports = exports;
